@if (availableFilters$ | async; as availableFilters) {
  <dv-filter-area
    class="page-actions__filter-area"
    [availableFilters]="availableFilters | vtFilterPermissions"
    [isFilterPanelOpen]="isFleetFilterAreaOpen"
    [openPanelTooltip]="'General.FilterPanel.Open' | translate"
    [closePanelTooltip]="'General.FilterPanel.Close' | translate"
    [addFilterFn]="addFilterFn"
    (activeFilterChanged)="onActiveFilterChanged($event)"
    (filterAreasVisibilityToggled)="
      onFilterAreaToggled($event)
    "></dv-filter-area>
}
<div class="page-actions">
  <dv-button
    color="primary"
    icon="add"
    (click)="onCreateClick()"
    [disabled]="(canAddVehicle$ | async) === false"
    routerLink="new/information">
    {{ 'Vehicle' | translate | uppercase }}
  </dv-button>
  <dv-button
    (click)="onShowAllVehiclesClick()"
    [disabled]="(canSeeMap$ | async) === false || disableMapBtn">
    {{ 'Vehicles.ShowAllVehicles' | translate | uppercase }}
  </dv-button>
</div>

<dv-vertical-splitter
  id="vehicles-vertical-splitter"
  [resizableSide]="resizableSide.Right">
  <div left-side>
    <app-vehicles-grid
      #vehiclesGrid
      (gridFiltersCleared)="vehiclesGridFiltersCleared()"></app-vehicles-grid>
  </div>
  <div right-side>
    <router-outlet />
  </div>
</dv-vertical-splitter>

<ng-template #menuPanelTemplate>
  <app-timed-marker-map-menu-panel
    [customForm]="customSettingsForm"
    [customFormElements]="customSettingsElements"
    [mapSetting]="mapSetting"
    [showCarIcons]="metaDataService.hasVehicleTrackingDomain()"
    [showMaintainersLegend]="metaDataService.hasSkiDomain()"
    (autoRefreshClicked)="onAutoRefreshClicked($event)"
    (autoZoomFitClicked)="onAutoZoomFitClicked($event)"
    (groupMarkersClicked)="onGroupMarkersClicked($event)"
    (customFormChanged)="onCustomSettingsChanged($event)">
  </app-timed-marker-map-menu-panel>
</ng-template>
